import type { Root } from 'react-dom/client'
import type { ReactNode } from 'react'
import { Button, Confirmation, IconSprite } from 'admination-react'
import { App, Splash } from './App'
import { loadRuntimeConfig } from './core/api/runtimeConfig'
import { icons } from './core/templates'

function ConfigUnavailable({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="page">
      <div className="layout layout--center" id="base-layout">
        <div className="confirmation-panel">
          <Confirmation tone="error" title="Admination konnte nicht geladen werden" inline>
            Der Server antwortet gerade nicht. Bitte versuchen Sie es erneut.</Confirmation>
          <div className="confirmation-actions">
            <Button variant="primary" onClick={onRetry}>
              Erneut versuchen</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export function boot(root: Root): void {
  const render = (page: ReactNode) => root.render(<><IconSprite registry={icons} />{page}</>)
  render(<Splash label="Admination wird geladen …" />)
  loadRuntimeConfig().then(
    () => render(<App />),
    (error: unknown) => {
      console.error(error)
      render(<ConfigUnavailable onRetry={() => boot(root)} />)
    },
  )
}
